document.documentElement.classList.add('js');

document.addEventListener('click', function(e){
  const t=e.target;
  if(t.closest('[data-drawer-open]')) document.querySelector('.drawer')?.classList.add('open');
  if(t.closest('[data-drawer-close]')) document.querySelector('.drawer')?.classList.remove('open');
  if(t.closest('[data-cart-open]')) document.querySelector('.cart-drawer')?.classList.add('open');
  if(t.closest('[data-cart-close]')) document.querySelector('.cart-drawer')?.classList.remove('open');
});

function buildPersonalisationFileInputs(input){
  const box = input.closest('[data-personalisation-box]');
  const hiddenWrap = box?.querySelector('[data-hidden-file-inputs]');
  const nameOutput = box?.querySelector('[data-file-name]');
  if(!hiddenWrap) return;

  const maxFiles = parseInt(input.getAttribute('data-max-files') || '5', 10);
  const files = Array.from(input.files || []).slice(0, maxFiles);

  hiddenWrap.innerHTML = '';

  files.forEach(function(file, index){
    const hiddenInput = document.createElement('input');
    hiddenInput.type = 'file';
    hiddenInput.name = 'properties[Design file ' + (index + 1) + ']';
    hiddenInput.style.display = 'none';

    const transfer = new DataTransfer();
    transfer.items.add(file);
    hiddenInput.files = transfer.files;

    hiddenWrap.appendChild(hiddenInput);
  });

  if(input.files && input.files.length > maxFiles){
    input.value = '';
    if(nameOutput){
      nameOutput.textContent = 'Please select up to ' + maxFiles + ' files only.';
    }
    hiddenWrap.innerHTML = '';
    return;
  }

  if(nameOutput){
    nameOutput.textContent = files.length ? 'Selected files: ' + files.map(function(file){ return file.name; }).join(', ') : '';
  }
}

document.addEventListener('change', function(e){
  const input = e.target.closest('[data-file-upload]');
  if(!input) return;
  buildPersonalisationFileInputs(input);
});

document.addEventListener('click', function(e){
  const minus = e.target.closest('[data-qty-minus]');
  const plus = e.target.closest('[data-qty-plus]');
  if(!minus && !plus) return;
  const wrapper = e.target.closest('[data-quantity-wrapper]');
  const input = wrapper?.querySelector('input[name="quantity"]');
  if(!input) return;
  const min = parseInt(input.getAttribute('min') || '1', 10);
  const current = parseInt(input.value || String(min), 10) || min;
  input.value = plus ? current + 1 : Math.max(min, current - 1);
  input.dispatchEvent(new Event('change', { bubbles: true }));
});

document.addEventListener('click', function(e){
  const open = e.target.closest('[data-quick-view-open]');
  if(open){
    e.preventDefault();
    const modal = document.getElementById(open.getAttribute('data-quick-view-open'));
    if(modal){ modal.classList.add('open'); modal.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; }
  }
  if(e.target.closest('[data-quick-view-close]')){
    const modal = e.target.closest('.quick-view-modal');
    if(modal){ modal.classList.remove('open'); modal.setAttribute('aria-hidden','true'); document.body.style.overflow=''; }
  }
});
document.addEventListener('keydown', function(e){
  if(e.key !== 'Escape') return;
  document.querySelectorAll('.quick-view-modal.open').forEach(function(modal){ modal.classList.remove('open'); modal.setAttribute('aria-hidden','true'); });
  document.body.style.overflow='';
});

document.addEventListener('click', function(event) {
  var btn = event.target.closest('[data-copy-link]');
  if (!btn) return;
  var url = btn.getAttribute('data-copy-link');
  if (navigator.clipboard && url) {
    navigator.clipboard.writeText(url).then(function(){
      btn.classList.add('is-copied');
      var old = btn.innerHTML;
      btn.innerHTML = '<span>✓</span>';
      setTimeout(function(){ btn.innerHTML = old; btn.classList.remove('is-copied'); }, 1400);
    });
  }
});


// Premium search drawer - safe upgrade
(function(){
  var openers=document.querySelectorAll('[data-search-open]');
  var drawer=document.querySelector('[data-search-drawer]');
  var overlay=document.querySelector('[data-search-overlay]');
  var closers=document.querySelectorAll('[data-search-close]');
  function openSearch(){ if(!drawer) return; drawer.hidden=false; if(overlay) overlay.hidden=false; drawer.setAttribute('aria-hidden','false'); var input=drawer.querySelector('input[type="search"]'); setTimeout(function(){ if(input) input.focus(); },80); }
  function closeSearch(){ if(!drawer) return; drawer.hidden=true; if(overlay) overlay.hidden=true; drawer.setAttribute('aria-hidden','true'); }
  openers.forEach(function(btn){btn.addEventListener('click',openSearch);});
  closers.forEach(function(btn){btn.addEventListener('click',closeSearch);});
  if(overlay) overlay.addEventListener('click',closeSearch);
  document.addEventListener('keydown',function(e){ if(e.key==='Escape') closeSearch(); });
  var form=drawer&&drawer.querySelector('form');
  if(form){ form.addEventListener('submit',function(){ var q=(form.querySelector('input[name="q"]')||{}).value||''; q=q.trim(); if(!q) return; var recent=JSON.parse(localStorage.getItem('twm_recent_searches')||'[]').filter(Boolean); recent=[q].concat(recent.filter(function(x){return x.toLowerCase()!==q.toLowerCase();})).slice(0,6); localStorage.setItem('twm_recent_searches',JSON.stringify(recent)); }); }
  var wrap=document.querySelector('[data-recent-searches-wrap]'), list=document.querySelector('[data-recent-searches]');
  if(wrap&&list){ var recent=JSON.parse(localStorage.getItem('twm_recent_searches')||'[]'); if(recent.length){ wrap.hidden=false; list.innerHTML=recent.map(function(q){ return '<a href="/search?type=product,page,article&q='+encodeURIComponent(q)+'">'+q.replace(/[&<>]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;'}[c];})+'</a>'; }).join(''); } }
})();
